import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";
import CreateWorkOrders from "./Tabs/createWorkOrders";
import WorkordersTab from "./Tabs/workordersTab";
import SearchJob from "./Tabs/searchTab";
import CreateJob from "./Tabs/createTab";
import EditJob from "./Tabs/editTab";

export default function CreateJobNotification() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();

  const handleChangeTab = (key) => {
    if (key !== state?.name)
      navigate("/general_job/create", { state: { name: key } });

    handleChangeWebsiteTab({
      key: key === "issue" ? `${key}.${state?.type || "create"}` : key,
      setWebsiteName,
      tabNames: {
        create: "สร้างใบแจ้งงาน",
        edit: "แก้ไขใบแจ้งงาน",
        data: "ข้อมูลใบแจ้งงาน",
        issue: { create: "สร้างใบสั่งงาน", workorder: "ข้อมูลใบสั่งงาน" }
      }
    });
  };

  useEffect(() => handleChangeTab(state?.name || "create"), []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Create a job notification Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey={state?.name || "create"}
          onSelect={(k) => handleChangeTab(k)}
        >
          <Tab eventKey="create" title="สร้างใบแจ้งงาน">
            {websiteName === "สร้างใบแจ้งงาน" && <CreateJob />}
          </Tab>
          <Tab eventKey="edit" title="แก้ไขใบแจ้งงาน">
            {websiteName === "แก้ไขใบแจ้งงาน" && <EditJob />}
          </Tab>
          <Tab eventKey="data" title="ข้อมูลใบแจ้งงาน">
            {websiteName === "ข้อมูลใบแจ้งงาน" && <SearchJob />}
          </Tab>
          <Tab eventKey="issue" title="สร้างใบสั่งงาน">
            {state?.type === "workorder" ? (
              <WorkordersTab />
            ) : (
              <CreateWorkOrders />
            )}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
